import React, { useEffect, useState, } from 'react';
import styled from 'styled-components';
import THEME from '../theme';
import Panel from './Panel';
export const HEIGHT = 540;
const Tooltip = (props) => {
    const [position, setPosition] = useState({});
    const height = props.height || HEIGHT;
    useEffect(() => {
        var _a, _b;
        const parentNode = (_b = (_a = props.parentRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect();
        const shouldShowOnTop = parentNode.y + parentNode.height + height >= screen.height &&
            parentNode.y >= height;
        props.setShowTooltipOnTop(shouldShowOnTop);
        props.setIsMounted && props.setIsMounted(true);
    }, []);
    useEffect(() => {
        var _a, _b;
        const newPosition = {};
        const parentNode = (_b = (_a = props.parentRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect();
        if (props.tooltipToLeft) {
            newPosition.right = `${screen.width - parentNode.x - parentNode.width}px`;
        }
        newPosition.top = `${props.shouldShowOnTop
            ? parentNode.top - height
            : parentNode.top + parentNode.height}px`;
        setPosition(newPosition);
    }, [props.parentRef, props.tooltipToLeft, props.shouldShowOnTop]);
    return (React.createElement(TooltipStyled, { className: "preview-tooltip", style: Object.assign(Object.assign({}, position), props.style), height: height }, props.children));
};
export default Tooltip;
const TooltipStyled = styled(Panel) `
  position: fixed;
  z-index: 1000;
  background-color: ${THEME.BACKGROUND};
  width: 100vw;
  box-shadow: 0 0 15px 5px rgba(0, 0, 0, 0.03);
  max-width: 615px;
  margin-top: -1px;
  * {
    float: none;
  }

  & > div > div.body {
    height: ${(props) => props.height}px !important;
    max-height: ${(props) => props.height}px !important;
    overflow-x: auto;
    font-size: 1rem;
  }
  div.body .body {
    max-height: none;
  }
`;
//# sourceMappingURL=Tooltip.js.map